/* This file is autogenerated, see readme.md for instructions */
import CustomersFilterSvgIcon from '@bloomreach/banana-theme/icons/customers-filter.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CustomersFilterIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CustomersFilterSvgIcon />
    </Icon>
  );
});

CustomersFilterIcon.displayName = 'CustomersFilterIcon';

export default CustomersFilterIcon;
